/**
 * Integrytas Group - Common Security Module (CSM)
 * Application scoping for csm_page_master.
 *
 * csm_page_master is a universal capability catalog: rows belong either to the
 * Base (default) Application — its own navigable React pages — or to some OTHER
 * application, where they are registered "actions" (capabilities), NEVER shown in
 * navigation. Navigation surfaces (menu tree, command palette, breadcrumbs) must
 * only ever show pages of the DEFAULT application.
 *
 * "The default application" is resolved generically as
 * csm_application_master.is_default = 'Y' — never a hard-coded application code.
 */

/**
 * Is a page navigable, given its application_id and the resolved default
 * application id?
 *
 *  - A NULL application_id is treated as the default application (legacy / Base
 *    rows predating the application_id column, backfilled to the default).
 *  - Fail-open: if the default application can't be resolved (`defaultAppId` is
 *    null — e.g. the applications table isn't seeded), nothing is hidden.
 */
export function isNavigableApplication(
  applicationId: number | null | undefined,
  defaultAppId: number | null | undefined,
): boolean {
  if (defaultAppId == null) return true; // fail-open: no default resolved → don't hide anything
  return applicationId == null || applicationId === defaultAppId;
}
